import React, { useState, createContext } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import ConfirmationModal from "../../components/ConfirmationModal";
import IgnoreContactModal from "../../components/IgnoreContactModal";

const IgnoreModalContext = createContext();

export const IgnoreModalProvider = ({ children }) => {
	const [ignoreTicketModalOpen, setIgnoreTicketModalOpen] = useState(false);
	const [ignoreContactModalOpen, setIgnoreContactModalOpen] = useState(false);
	const [ticketToIgnore, setTicketToIgnore] = useState(null);

	const handleOpenIgnoreModal = (ticket) => {
		setIgnoreContactModalOpen(false);
		setTicketToIgnore(ticket);
		setIgnoreTicketModalOpen(true);
	};
  
	const handleConfirmIgnoreTicket = async (ticket) => {
		if (!ticket) return;

		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: "rejected",
				userId: ticket.userId || null,
				queueId: ticket.queueId || null,
			});
			toast.success("Ticket ignorado correctamente");
			
			setIgnoreTicketModalOpen(false);
			setTicketToIgnore(ticket);
			setIgnoreContactModalOpen(true);

		} catch (err) {
			toastError(err);
			setIgnoreTicketModalOpen(false);
			setTicketToIgnore(null);
		}
	};
	
	const handleCloseAndClear = () => {
		setIgnoreTicketModalOpen(false);
		setIgnoreContactModalOpen(false);
		setTicketToIgnore(null);
	};

	return (
		<IgnoreModalContext.Provider value={{ handleOpenIgnoreModal }}>
			{children}
			{ticketToIgnore && (
				<>
					<ConfirmationModal
						open={ignoreTicketModalOpen}
						title={`Ignorar Ticket de "${ticketToIgnore.contact?.name}"`}
						onClose={handleCloseAndClear}
						onConfirm={() => handleConfirmIgnoreTicket(ticketToIgnore)}
					>
						{"¿Está seguro de ignorar este ticket? A continuación, se le preguntará si desea ignorar todos los mensajes futuros de este contacto."}
					</ConfirmationModal>
					
					<IgnoreContactModal
						open={ignoreContactModalOpen}
						onClose={handleCloseAndClear}
						contactId={ticketToIgnore.contact?.id}
						contactName={ticketToIgnore.contact?.name}
					/>
				</>
			)}
		</IgnoreModalContext.Provider>
	);
};

export default IgnoreModalContext;